import { LogsArchivingComponent } from './../logs-archiving/component/logs-archiving.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from '../login/component/login.component';

import { LogListComponent } from '../log/component/log-list/log-list.component';
import { LogSapComponent } from '../logsap/component/logsap/logsap.component';

import { UserListComponent } from '../user/component/user-list/user-list.component';
import { UserEditComponent } from '../user/component/user-edit/user-edit.component';

import { GroupListComponent } from '../group/component/group-list/group-list.component';
import { GroupEditComponent } from '../group/component/group-edit/group-edit.component';

import { AccountClientListComponent } from '../account-client/component/account-client-list/account-client-list.component';
import { AccountClientDetailsComponent } from '../account-client/component/account-client-details/account-client-details.component';
import { AccountClientByCodeComponent } from '../account-client/component/account-client-bycode/account-client-bycode.component';
import { AccountClientLogComponent } from '../account-client/component/account-client-log/account-client-log.component';

import { AccountClientSimplifiedComponent } from "../account-client-simplified/component/account-client-simplified/account-client-simplified.component";

import { UserInsertComponent } from '../user/component/user-insert/user-insert.component';
import { GroupInsertComponent } from '../group/component/group-insert/group-insert.component';

import { ClientTypeListComponent } from '../client-type/component/client-type-list/client-type-list.component';
import { ClientTypeInsertComponent } from '../client-type/component/client-type-insert/client-type-insert.component';
import { ClientTypeEditComponent } from '../client-type/component/client-type-edit/client-type-edit.component';

import { CollectStatusListComponent } from '../collect-status/component/collect-status-list/collect-status-list.component';
import { CollectStatusInsertComponent } from '../collect-status/component/collect-status-insert/collect-status-insert.component';
import { CollectStatusEditComponent } from '../collect-status/component/collect-status-edit/collect-status-edit.component';

import { SegmentListComponent } from '../segments/component/segment-list/segment-list.component';
import { SegmentInsertComponent } from '../segments/component/segment-insert/segment-insert.component';
import { SegmentEditComponent } from '../segments/component/segment-edit/segment-edit.component';

import { BillingConceptListComponent } from '../billing-concept/component/billing-concept-list/billing-concept-list.component';
import { BillingConceptInsertComponent } from '../billing-concept/component/billing-concept-insert/billing-concept-insert.component';
import { BillingConceptEditComponent } from '../billing-concept/component/billing-concept-edit/billing-concept-edit.component';

import { CultureListComponent } from '../culture/component/culture-list/culture-list.component';
import { CultureEditComponent } from '../culture/component/culture-edit/culture-edit.component';
import { CultureInsertComponent } from '../culture/component/culture-insert/culture-insert.component';

import { StateCultureListComponent } from '../stateculture/component/stateculture-list/stateculture-list.component';
import { StateCultureEditComponent } from '../stateculture/component/stateculture-edit/stateculture-edit.component';
import { StateCultureInsertComponent } from '../stateculture/component/stateculture-insert/stateculture-insert.component';

import { ExperienceListComponent } from '../experience/component/experience-list/experience-list.component';
import { ExperienceEditComponent } from '../experience/component/experience-edit/experience-edit.component';
import { ExperienceInsertComponent } from '../experience/component/experience-insert/experience-insert.component';

import { RevenueTypeListComponent } from '../revenue-type/component/revenue-type-list/revenue-type-list.component';
import { RevenueTypeEditComponent } from '../revenue-type/component/revenue-type-edit/revenue-type-edit.component';
import { RevenueTypeInsertComponent } from '../revenue-type/component/revenue-type-insert/revenue-type-insert.component';

import { CompanyTypeListComponent } from '../company-type/component/company-type-list/company-type-list.component';
import { CompanyTypeEditComponent } from '../company-type/component/company-type-edit/company-type-edit.component';
import { CompanyTypeInsertComponent } from '../company-type/component/company-type-insert/company-type-insert.component';

import { GuaranteeTypeListComponent } from '../guarantee-type/component/guarantee-type-list/guarantee-type-list.component';
import { GuaranteeTypeEditComponent } from '../guarantee-type/component/guarantee-type-edit/guarantee-type-edit.component';
import { GuaranteeTypeInsertComponent } from '../guarantee-type/component/guarantee-type-insert/guarantee-type-insert.component';

import { AreaListComponent } from '../area/component/area-list/area-list.component';
import { AreaEditComponent } from '../area/component/area-edit/area-edit.component';
import { AreaInsertComponent } from '../area/component/area-insert/area-insert.component';

import { ProductListComponent } from '../product/component/product-list/product-list.component';
import { ProductEditComponent } from '../product/component/product-edit/product-edit.component';
import { ProductInsertComponent } from '../product/component/product-insert/product-insert.component';

import { AverageageofsugarcaneListComponent } from '../averageageofsugarcane/component/averageageofsugarcane-list/averageageofsugarcane-list.component';
import { AverageageofsugarcaneEditComponent } from '../averageageofsugarcane/component/averageageofsugarcane-edit/averageageofsugarcane-edit.component';
import { AverageageofsugarcaneInsertComponent } from '../averageageofsugarcane/component/averageageofsugarcane-insert/averageageofsugarcane-insert.component';

import { UnitofmeasurementcultureListComponent } from '../unitofmeasurementculture/component/unitofmeasurementculture-list/unitofmeasurementculture-list.component';
import { UnitofmeasurementcultureEditComponent } from '../unitofmeasurementculture/component/unitofmeasurementculture-edit/unitofmeasurementculture-edit.component';
import { UnitofmeasurementcultureInsertComponent } from '../unitofmeasurementculture/component/unitofmeasurementculture-insert/unitofmeasurementculture-insert.component';

import { ProductivityListComponent } from '../productivity/component/productivity-list/productivity-list.component';
import { ProductivityEditComponent } from '../productivity/component/productivity-edit/productivity-edit.component';
import { ProductivityInsertComponent } from '../productivity/component/productivity-insert/productivity-insert.component';

import { PercentageofbreakListComponent } from '../percentageofbreak/component/percentageofbreak-list/percentageofbreak-list.component';
import { PercentageofbreakEditComponent } from '../percentageofbreak/component/percentageofbreak-edit/percentageofbreak-edit.component';
import { PercentageofbreakInsertComponent } from '../percentageofbreak/component/percentageofbreak-insert/percentageofbreak-insert.component';

import { PriceListComponent } from '../price/component/price-list/price-list.component';
import { PriceEditComponent } from '../price/component/price-edit/price-edit.component';
import { PriceInsertComponent } from '../price/component/price-insert/price-insert.component';

import { LivestocktypeListComponent } from '../livestocktype/component/livestocktype-list/livestocktype-list.component';
import { LivestocktypeEditComponent } from '../livestocktype/component/livestocktype-edit/livestocktype-edit.component';
import { LivestocktypeInsertComponent } from '../livestocktype/component/livestocktype-insert/livestocktype-insert.component';

import { CostharegionListComponent } from '../costharegion/component/costharegion-list/costharegion-list.component';
import { CostharegionEditComponent } from '../costharegion/component/costharegion-edit/costharegion-edit.component';
import { CostharegionInsertComponent } from '../costharegion/component/costharegion-insert/costharegion-insert.component';

import { MovecustomerstructureComponent } from '../movecustomerstructure/component/movecustomerstructure/movecustomerstructure.component';
import { ParametersComponent } from '../parameters/component/parameters/parameters.component';
import { CockpitComponent } from '../cockpit/component/cockpit/cockpit.component';

import { TypeOfIndebtednessListComponent } from '../type-of-indebtedness/component/type-of-indebtedness-list/type-of-indebtedness-list.component';
import { TypeOfIndebtednessEditComponent } from '../type-of-indebtedness/component/type-of-indebtedness-edit/type-of-indebtedness-edit.component';
import { TypeOfIndebtednessInsertComponent } from '../type-of-indebtedness/component/type-of-indebtedness-insert/type-of-indebtedness-insert.component';

import { CommercialStructureListComponent } from '../commercial-structure/component/commercial-structure-list/commercial-structure-list.component';
import { CommercialStructureEditComponent } from '../commercial-structure/component/commercial-structure-edit/commercial-structure-edit.component';
import { CommercialStructureInsertComponent } from '../commercial-structure/component/commercial-structure-insert/commercial-structure-insert.component';

import { UiComponentComponent } from '../ui-component/ui-component.component';

import { OrderDetailComponent } from './../order/component/order-detail/order-detail.component';
import { OrderListComponent } from './../order/component/order-list/order-list.component';

import { UnauthorizedComponent } from './../unauthorized/component/unauthorized.component';

import { AttachmentListComponent } from '../attachment/component/attachment-list/attachment-list.component';
import { AttachmentEditComponent } from '../attachment/component/attachment-edit/attachment-edit.component';
import { AttachmentInsertComponent } from '../attachment/component/attachment-insert/attachment-insert.component';

import { LimitFlowProposalComponent } from './../limit-flow-proposal/component/limit-flow-proposal/limit-flow-proposal.component';

import { HolidaysInsertComponent } from "../holidays/component/holidays-insert/holidays-insert.component";
import { LimitFlowSalesOrderComponent } from "../limit-flow-sales-order/component/sales-order/sales-order.component";
import { LimitFlowAllowanceComponent } from "../limit-flow-allowance/component/limit-flow-allowance/limit-flow-allowance.component";
import { LimitFlowReprieveComponent } from "../limit-flow-reprieve/component/limit-flow-reprieve/limit-flow-reprieve.component";
import { FindOrderComponent } from "../find-order/component/find-order.component";
import { EconomicGroupComponent } from "../economic-group/component/economic-group/economic-group.component";
import { EconomicGroupFlowComponent } from "../economic-group-flow/component/economic-group-flow/economic-group-flow.component";
import { ProfileUserComponent } from "../profile-user/component/profile-user/profile-user.component";
import { RelationsComponent } from "../relations/component/relations/relations.component";

import { EconomicGroupEditComponent } from "../economic-group/component/economic-group-edit/economic-group-edit.component";
import { RelationTypeEditComponent } from '../relations/component/relations-edit/relations-edit.component';
import { RelationTypeInsertComponent } from '../relations/component/relations-insert/relations-insert.component';
import { ProposalApproverComponent } from '../proposal-approver/component/proposal-approver/proposal-approver.component';
import { BillingControlComponent } from '../billing-control/billing-control/billing-control.component';

import { ReasonOfAllowanceListComponent } from '../reason-of-allowance/component/reason-of-allowance-list/reason-of-allowance-list.component';
import { ReasonOfAllowanceEditComponent } from '../reason-of-allowance/component/reason-of-allowance-edit/reason-of-allowance-edit.component';
import { ReasonOfAllowanceInsertComponent } from '../reason-of-allowance/component/reason-of-allowance-insert/reason-of-allowance-insert.component';

import { ReasonOfExtensionListComponent } from '../reason-of-extension/component/reason-of-extension-list/reason-of-extension-list.component';
import { ReasonOfExtensionEditComponent } from '../reason-of-extension/component/reason-of-extension-edit/reason-of-extension-edit.component';
import { ReasonOfExtensionInsertComponent } from '../reason-of-extension/component/reason-of-extension-insert/reason-of-extension-insert.component';

import { MoneySourceListComponent } from '../money-source/component/money-source-list/money-source-list.component';
import { MoneySourceInsertComponent } from '../money-source/component/money-source-insert/money-source-insert.component';
import { MoneySourceEditComponent } from '../money-source/component/money-source-edit/money-source-edit.component';
import { OrderRequisitionsComponent } from '../order-requisitions/order-requisitions/order-requisitions.component';

import { MonitorComponent } from '../monitor/component/monitor.component';

import { ProposalComponent } from '../report/component/proposal/proposal.component';
import { BulkRenewalRequestComponent } from '../bulk-renewal/component/bulk-renewal-request/bulk-renewal-request.component';
import { BulkRenewalComponent } from '../bulk-renewal/component/bulk-renewal/bulk-renewal.component';
import { BulkRenewalFlowComponent } from '../bulk-renewal-flow/component/bulk-renewal-flow/bulk-renewal-flow.component';
import { LimiteAdicionalProposalComponent } from '../limite-adicional-proposal/component/limite-adicional-proposal/limite-adicional-proposal.component';
import { AditionalProposalApproverComponent } from '../aditional-proposal-approver/component/aditional-proposal-approver/aditional-proposal-approver.component';
import { AnalysisApproverComponent } from '../analysis-approver/component/analysis-approver/analysis-approver.component';
import { AcceptanceApproverComponent } from '../acceptance-approver/component/acceptance-approver/acceptance-approver.component';

const routes: Routes = [
	{ path: '', component: LoginComponent, },
	{ path: 'login', component: LoginComponent, },
	{ path: 'login/sf/:code', component: LoginComponent, },
	{ path: 'login/sfcc/:ccid/:code', component: LoginComponent, },
	{ path: 'cockpit', component: CockpitComponent, },
	{ path: 'usuarios', component: UserListComponent, },
	{ path: 'usuarios/detalhe/:guid', component: UserEditComponent, },
	{ path: 'usuarios-novo', component: UserInsertComponent, },
	{ path: 'grupo-usuario', component: GroupListComponent, },
	{ path: 'grupo-usuario/detalhe/:guid', component: GroupEditComponent, },
	{ path: 'grupo-usuario-novo', component: GroupInsertComponent, },
	{ path: 'conta-cliente', component: AccountClientListComponent, },
	{ path: 'conta-cliente/detalhe/:guid/:action/:id', component: AccountClientDetailsComponent, },
	{ path: 'conta-cliente/detalhe/:guid/:action', component: AccountClientDetailsComponent, },
	{ path: 'conta-cliente/detalhe/:guid', component: AccountClientDetailsComponent, },
	{ path: 'conta-cliente/codigo/:codigo', component: AccountClientByCodeComponent, },
	{ path: 'tipo-cliente', component: ClientTypeListComponent, },
	{ path: 'tipo-cliente-novo', component: ClientTypeInsertComponent, },
	{ path: 'tipo-cliente/detalhe/:guid', component: ClientTypeEditComponent, },
	{ path: 'segmento', component: SegmentListComponent, },
	{ path: 'segmento-novo', component: SegmentInsertComponent, },
	{ path: 'segmento/detalhe/:guid', component: SegmentEditComponent, },
	{ path: 'conceito', component: BillingConceptListComponent, },
	{ path: 'conceito-novo', component: BillingConceptInsertComponent, },
	{ path: 'conceito/detalhe/:guid', component: BillingConceptEditComponent, },
	{ path: 'layout', component: UiComponentComponent, },
	{ path: 'logs', component: LogListComponent, },
	{ path: 'logsap', component: LogSapComponent, },
	{ path: 'cultura', component: CultureListComponent, },
	{ path: 'cultura/detalhe/:guid', component: CultureEditComponent, },
	{ path: 'cultura-novo', component: CultureInsertComponent, },
	{ path: 'culturaestado', component: StateCultureListComponent, },
	{ path: 'culturaestado/detalhe/:guid', component: StateCultureEditComponent, },
	{ path: 'culturaestado-novo', component: StateCultureInsertComponent, },
	{ path: 'experiencia', component: ExperienceListComponent, },
	{ path: 'experiencia/detalhe/:guid', component: ExperienceEditComponent, },
	{ path: 'experiencia-novo', component: ExperienceInsertComponent, },
	{ path: 'tipo-receita', component: RevenueTypeListComponent, },
	{ path: 'tipo-receita/detalhe/:guid', component: RevenueTypeEditComponent, },
	{ path: 'tipo-receita-novo', component: RevenueTypeInsertComponent, },
	{ path: 'tipo-empresa', component: CompanyTypeListComponent, },
	{ path: 'tipo-empresa/detalhe/:guid', component: CompanyTypeEditComponent, },
	{ path: 'tipo-empresa-novo', component: CompanyTypeInsertComponent, },
	{ path: 'tipo-garantia', component: GuaranteeTypeListComponent, },
	{ path: 'tipo-garantia/detalhe/:guid', component: GuaranteeTypeEditComponent, },
	{ path: 'tipo-garantia-novo', component: GuaranteeTypeInsertComponent, },
	{ path: 'area', component: AreaListComponent, },
	{ path: 'area/detalhe/:guid', component: AreaEditComponent, },
	{ path: 'area-novo', component: AreaInsertComponent, },
	{ path: 'produto-servico', component: ProductListComponent, },
	{ path: 'produto-servico/detalhe/:guid', component: ProductEditComponent, },
	{ path: 'produto-servico-novo', component: ProductInsertComponent, },
	{ path: 'idade-media-canavial', component: AverageageofsugarcaneListComponent, },
	{ path: 'idade-media-canavial/detalhe/:guid', component: AverageageofsugarcaneEditComponent, },
	{ path: 'idade-media-canavial-novo', component: AverageageofsugarcaneInsertComponent, },
	{ path: 'unidade-medida-cultura', component: UnitofmeasurementcultureListComponent, },
	{ path: 'unidade-medida-cultura/detalhe/:guid', component: UnitofmeasurementcultureEditComponent, },
	{ path: 'unidade-medida-cultura-novo', component: UnitofmeasurementcultureInsertComponent, },
	{ path: 'produtividade-media', component: ProductivityListComponent, },
	{ path: 'produtividade-media/detalhe/:guid', component: ProductivityEditComponent, },
	{ path: 'produtividade-media-novo', component: ProductivityInsertComponent, },
	{ path: 'porcentagem-quebra', component: PercentageofbreakListComponent, },
	{ path: 'porcentagem-quebra/detalhe/:guid', component: PercentageofbreakEditComponent, },
	{ path: 'porcentagem-quebra-novo', component: PercentageofbreakInsertComponent, },
	{ path: 'media-saca', component: PriceListComponent, },
	{ path: 'media-saca/detalhe/:guid', component: PriceEditComponent, },
	{ path: 'media-saca-novo', component: PriceInsertComponent, },
	{ path: 'tipo-pecuaria', component: LivestocktypeListComponent, },
	{ path: 'tipo-pecuaria/detalhe/:guid', component: LivestocktypeEditComponent, },
	{ path: 'tipo-pecuaria-novo', component: LivestocktypeInsertComponent, },
	{ path: 'custo-regiao', component: CostharegionListComponent, },
	{ path: 'custo-regiao/detalhe/:guid', component: CostharegionEditComponent, },
	{ path: 'custo-regiao-novo', component: CostharegionInsertComponent, },
	{ path: 'mover-estrutura-cliente', component: MovecustomerstructureComponent, },
	{ path: 'mover-estrutura-cliente/:CodigoPrincipal/:ContaClienteID', component: MovecustomerstructureComponent, },
	{ path: 'parametros', component: ParametersComponent, },
	{ path: 'tipo-endividamento', component: TypeOfIndebtednessListComponent, },
	{ path: 'tipo-endividamento/detalhe/:guid', component: TypeOfIndebtednessEditComponent, },
	{ path: 'tipo-endividamento-novo', component: TypeOfIndebtednessInsertComponent, },
	{ path: 'estrutura-comercial', component: CommercialStructureListComponent, },
	{ path: 'estrutura-comercial/detalhe/:guid', component: CommercialStructureEditComponent, },
	{ path: 'estrutura-comercial-novo', component: CommercialStructureInsertComponent, },
	{ path: 'fluxo-ordens', component: LimitFlowSalesOrderComponent },
	{ path: 'fluxo-abono', component: LimitFlowAllowanceComponent },
	{ path: 'fluxo-prorrogacao', component: LimitFlowReprieveComponent},
	{ path: 'ordem-venda/detalhe/:Divisao/:ItemOrdemVendaItem/:OrdemVendaNumero', component: OrderDetailComponent },
	{ path: 'ordem-venda/detalhe/:OrdemVendaNumero', component: OrderDetailComponent },
	{ path: 'ordem-requisicao/:id', component: OrderRequisitionsComponent },
	{ path: 'unauthorized/:type', component: UnauthorizedComponent },
	{ path: 'anexo', component: AttachmentListComponent, },
	{ path: 'anexo/detalhe/:guid', component: AttachmentEditComponent, },
	{ path: 'anexo-novo', component: AttachmentInsertComponent, },
	{ path: 'proposta-lc/:guid', component: LimitFlowProposalComponent },
	{ path: 'proposta-la/:guid', component: LimiteAdicionalProposalComponent },
	{ path: 'unauthorized/:type', component: UnauthorizedComponent },
	{ path: 'feriados', component: HolidaysInsertComponent },
	{ path: 'encontrar-ordem', component: FindOrderComponent },
	{ path: 'conta-cliente-simples/:guid', component: AccountClientSimplifiedComponent },
	{ path: 'grupos-economicos', component: EconomicGroupComponent }, // **** TEMP ROUTE ****
	{ path: 'grupo-economico-fluxo', component: EconomicGroupFlowComponent },
	{ path: 'relacoes', component: RelationsComponent },
	{ path: 'perfil-usuario', component: ProfileUserComponent },
	{ path: 'grupoeconomico-aprovar/:guid', component: EconomicGroupEditComponent},
	{ path: 'tipo-relacao/detalhe/:guid', component: RelationTypeEditComponent},
	{ path: 'tipo-relacao-novo', component: RelationTypeInsertComponent},
	{ path: 'fluxo-analise', component: AnalysisApproverComponent},
	{ path: 'fluxo-aprovacao', component: AcceptanceApproverComponent},
	{ path: 'fluxo-proposta', component: ProposalApproverComponent},
	{ path: 'fluxo-proposta-adicional', component: AditionalProposalApproverComponent},
	{ path: 'controle-cobranca', component: BillingControlComponent},
	{ path: 'controle-cobranca/:idDiretoria', component: BillingControlComponent},
	{ path: 'status-cobranca', component: CollectStatusListComponent },
	{ path: 'status-cobranca-novo', component: CollectStatusInsertComponent },
	{ path: 'status-cobranca/detalhe/:guid', component: CollectStatusEditComponent},
	{ path: 'motivo-do-abono', component: ReasonOfAllowanceListComponent, },
	{ path: 'motivo-do-abono/detalhe/:guid', component: ReasonOfAllowanceEditComponent, },
	{ path: 'motivo-do-abono-novo', component: ReasonOfAllowanceInsertComponent, },
	{ path: 'motivo-de-prorrogacao', component: ReasonOfExtensionListComponent, },
	{ path: 'motivo-de-prorrogacao/detalhe/:guid', component: ReasonOfExtensionEditComponent, },
	{ path: 'motivo-de-prorrogacao-novo', component: ReasonOfExtensionInsertComponent, },
	{ path: 'origem-recurso', component: MoneySourceListComponent, },
	{ path: 'origem-recurso/detalhe/:guid', component: MoneySourceEditComponent, },
	{ path: 'relatorio/proposta', component:ProposalComponent,},
	{ path: 'origem-recurso-novo', component: MoneySourceInsertComponent, },
	{ path: 'monitor', component: MonitorComponent },
	{ path: 'renovacao-vigencia', component: BulkRenewalRequestComponent },
	{ path: 'renovacao-vigencia/:guid', component: BulkRenewalComponent },
	{ path: 'renovacao-vigencia-fluxo', component: BulkRenewalFlowComponent },
	{ path: 'logs-archiving', component: LogsArchivingComponent }
];

@NgModule({
	imports: [
		CommonModule,
		RouterModule.forRoot(routes)
	],
	exports: [
		RouterModule
	],
	declarations: []
})

export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing/app-routing.module.ts